const COMPANY_SESSION_BACKUP_KEY = "pondstat_company_session_backup";

function readCurrentSession() {
  try {
    const token = localStorage.getItem("auth_token");
    const refreshToken = localStorage.getItem("refresh_token");
    const raw = localStorage.getItem("user_data");
    if (!token || !raw) return null;
    const User = JSON.parse(raw);
    return { token, refreshToken, User };
  } catch {
    return null;
  }
}

/** Save company manager session before switching into a pond-owner account. */
export function stashCompanySessionIfNeeded() {
  const current = readCurrentSession();
  if (!current?.User) return false;
  const u = current.User;
  if (!(u.isCompanyManager || u.IsCompanyManager)) return false;
  localStorage.setItem(COMPANY_SESSION_BACKUP_KEY, JSON.stringify(current));
  return true;
}

export function getStashedCompanySession() {
  try {
    const raw = localStorage.getItem(COMPANY_SESSION_BACKUP_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.token || !data?.User) return null;
    return data;
  } catch {
    return null;
  }
}

export function clearStashedCompanySession() {
  localStorage.removeItem(COMPANY_SESSION_BACKUP_KEY);
}

export function hasStashedCompanySession() {
  return !!getStashedCompanySession();
}

/**
 * Open AdminPanel as a staff/owner user.
 * Uses same-tab navigation so handoff always runs even when already logged in
 * as a company manager on this origin (new-tab + shared localStorage failed before).
 */
export function openAsStaffUser(session, { replace = true } = {}) {
  if (!session?.token || !session?.User) {
    throw new Error("Missing session for login-as");
  }
  stashCompanySessionIfNeeded();

  const payload = encodeURIComponent(
    JSON.stringify({
      token: session.token,
      refreshToken: session.refreshToken,
      User: session.User,
    })
  );
  const url = `/user/admin-handoff#${payload}`;
  if (replace) {
    window.location.assign(url);
  } else {
    const opened = window.open(url, "_blank", "noopener,noreferrer");
    if (!opened) {
      window.location.assign(url);
    }
  }
}

/** Restore the stashed company manager session (full page reload). */
export function returnToCompanySession() {
  const backup = getStashedCompanySession();
  if (!backup?.token || !backup?.User) return false;
  clearStashedCompanySession();
  const payload = encodeURIComponent(JSON.stringify(backup));
  window.location.assign(`/user/admin-handoff#${payload}`);
  return true;
}
